import { render, staticRenderFns } from "./server-edit.vue?vue&type=template&id=7890b826&scoped=true&"
import script from "./server-edit.vue?vue&type=script&lang=js&"
export * from "./server-edit.vue?vue&type=script&lang=js&"
import style0 from "./server-edit.vue?vue&type=style&index=0&id=7890b826&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7890b826",
  null
  
)

export default component.exports